import ListAltIcon from '@material-ui/icons/ShortText';

const ElectricalReviewerSubitem = () => {
  const links = {
    subheader: 'Electrical Reviewer Submenu',
    owner: 'electrical-reviewer',
    items: [
      {
        title: 'Processed Permits',
        icon: ListAltIcon,
        href: '/electrical-reviewer/reviewed/request/permit/approved-list',
        enabled: true
      },

      {
        title: 'Processed Permits For Occupancy',
        icon: ListAltIcon,
        href:
          '/electrical-reviewer/reviewed/request/occupancy/permit/approved-list',
        enabled: true
      }
    ]
  };

  return links;
};

export default ElectricalReviewerSubitem;
